//时间格式化
import {formatDate} from "@/assets/js/date"

const filter: any = {
    formatDateAll(time: any){
        var date = new Date(time)
        return formatDate(date, "yyyy/MM/dd hh:mm")
    },
    formatDateHMS(time: any) {
        var date = new Date(time)
        return formatDate(date, "hh:mm:ss")
    },
    formatDateYMD(time: any) {
        var date = new Date(time)
        return formatDate(date, "yyyy-MM-dd")
    },
    // 输出XX月XX日XX:XX
    formatChineseDate(time: any){
        let date = new Date(time)
        return formatDate(date, "MM月dd日 hh:mm")
    },
    // 小数点前
    pointBefore(price:any){
        return (price + "").split(".")[0]
    },
    // 小数点后
    pointAfter(price:any){
        let val = (price + "").split(".")[1]

        if(!val){
            return "00"
        }else if(val.length == 1){
            return val + "0"
        }else{
            return val
        }
    },
    toFixedBroad(value:any) {
        if (!Number(value))
            return '? ? ?';
        else {
            value = Number(value || 0).toFixed(2);
            return value;
        }
    },
    replaceImg(url:string, d:string) {
        d = d ? d : 'l';
        if (!url)
            return '';
        return url.replace(/(.*)\./, '$1_' + d + '.')
    },
    numBefore(value:any) {
        if (value < 10)
            value = '0' + value
        return value
    },
    conversionW(value:any){
        if(value>=10000){
            value = Math.floor(value/10000 * 100) / 100 +'w';
        }
        return value;
    },
    hms(val:any){//秒为单位计算时分秒
        let h:any = Math.floor(val/3600);
        let m:any = Math.floor((val-h*3600)/60);
        let s:any = Math.floor(val - h*3600 - m*60)
        h =h>=10?h:'0'+ h;
        m =m>=10?m:'0'+ m;
        s =s>=10?s:'0'+ s;
        return h + ':' + m + ':' + s 
    },
    currency(v:any, c:any, d:any) {
        v = parseFloat(v);
        if (!isFinite(v) || (!v && v !== 0)) return "";
        c = c != null ? c : "¥";
        d = d != null ? d : 2;
        const digitsRE = /(\d{3})(?=\d)/g; // \d =[0~9],{3}匹配3次，
        const stringified = Math.abs(v).toFixed(d); // 保留2位小数
        const int = d ? stringified.slice(0, -1 - d) : stringified; // 取整
        const i = int.length % 3; //= >1
        const head = i > 0 ? int.slice(0, i) + (int.length > 3 ? "," : "") : ""; // 2,
        const float = d ? stringified.slice(-1 - d) : ""; // .20
        const sign = v < 0 ? "-" : "";
        return sign + c + head + int.slice(i).replace(digitsRE, "$1,") + float;
    }
}

export default filter
